import { colors, VStack, useResponsive, HStack } from "goi_common";
import SeaBurialTitleSection from "./components/SeaBurialTitleSection";
import seaburials from "@/constants/sea_burial_detail.json";
import { Box } from "@chakra-ui/react";
import SeaBurialTabSection from "./components/SeaBurialTabSection";

export default function FacilitiesSeaBurialContainer() {
  return (
    <VStack width="100%" alignItems="center">
      <VStack width="100%" maxWidth="480px" padding="24px 0">
        <SeaBurialTitleSection
          description={
            <>
              <span className="orange650">{seaburials.length}</span>개의 바다장례 업체를 비교,
              찾아보세요
            </>
          }
        />
        <SeaBurialHeadCTA />
        <SeaBurialTabSection regionSeaBurial={seaburials} eventPath="sea_burial" />
      </VStack>
    </VStack>
  );
}

function SeaBurialHeadCTA() {
  const { isBiggerThanMd } = useResponsive();
  return (
    <VStack gap="24px" padding={isBiggerThanMd ? "40px 0" : "40px 24px"}>
      <VStack
        padding="24px 16px"
        background={colors.gray50}
        borderRadius="10px"
        border={`1px solid ${colors.gray200}`}
        gap="7px"
      >
        <SeaBurialCTADetailItem district="인천" length={2} />
        <SeaBurialCTADetailItem district="경기" length={1} />
        <SeaBurialCTADetailItem district="부산" length={2} />
        <SeaBurialCTADetailItem district="포항" length={1} />
      </VStack>
      <Box padding="0 16px" className="body_14_l gray800">
        현행법상 유골을 임의로 바다에 뿌리는 것은 불법입니다. 반드시 적법한 절차에 따라 바다장을
        이용할 수 있도록 미리 알아보고 진행하시기 바랍니다.
      </Box>
    </VStack>
  );
}

function SeaBurialCTADetailItem({ district, length }: { district: string; length: number }) {
  return (
    <HStack justifyContent="space-between" alignItems="center" gap="10px">
      <Box className="body_16_m" flexShrink={0}>
        <span className="orange650">{district}</span> 바다장
      </Box>
      <Box height="0.8px" width="100%" overflow="hidden">
        <Box width="100%" borderTopWidth="3px" borderStyle="dashed" borderColor={colors.gray600} />
      </Box>

      <Box className="body_16_m" flexShrink={0}>
        <span className="orange650">{length}</span>개 업체
      </Box>
    </HStack>
  );
}
